import { useCallback, useEffect, useState } from 'react'
import { backendClient } from '../../interactors/clients/client'

export type StripeConnectStatus = 'loading' | 'connected' | 'missing'

export const useStripeConnectStatus = (enabled = true): { status: StripeConnectStatus; refresh: () => void } => {
  const [status, setStatus] = useState<StripeConnectStatus>('loading')
  const [refreshIndex, setRefreshIndex] = useState(0)

  const refresh = useCallback(() => {
    setRefreshIndex((prev) => prev + 1)
  }, [])

  useEffect(() => {
    if (!enabled) {
      return
    }
    let isMounted = true
    setStatus('loading')

    const fetchStatus = async () => {
      try {
        const response = await backendClient.get('/customers/stripe-connect-status')
        if (!isMounted) return
        const connected = response.data === true || response.data === 'valid'
        setStatus(connected ? 'connected' : 'missing')
      } catch (error) {
        if (!isMounted) return
        setStatus('missing')
      }
    }

    fetchStatus()

    return () => {
      isMounted = false
    }
  }, [enabled, refreshIndex])

  return { status, refresh }
}
